import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import IframeLayout from '../components/iframe-layout/iframe-layout';
import IframePromo from '../components/iframe-promo/iframe-promo';

const SSPolicePromo = ({ data }) => {
  // Pull out the relevant content from the data.
  // Make sure at least one result is returned before rendering the layout.
  const content = data.allTaxonomyTermPromotion.edges[0]?.node.relationships
    ? data.allTaxonomyTermPromotion.edges[0].node.relationships
      .field_promoted_content[0]
    : null;

  return (
    <React.Fragment>
      {content && (
        <IframeLayout>
          <IframePromo content={content} />
        </IframeLayout>
      )}
    </React.Fragment>
  );
};

SSPolicePromo.propTypes = {
  data: PropTypes.object
};

export default SSPolicePromo;

export const query = graphql`
  query SSPolice {
    allTaxonomyTermPromotion(filter: { drupal_id: { eq: "ce0fa141-273b-40df-a986-f7f979aa9f8e" } }) {
      edges {
        node {
          name
          relationships {
            field_promoted_content {
              ...IframeEvent
              ...IframeNews
              ...IframePlace
            }
          }
        }
      }
    }
  }
`;
